export const FILTER_OPTIONS = {
  crossClub: ["Cross Club", "Clients"],
  groupBy: ["New/Existing", "Cross Club", "Members/Non-Members"]
};
